import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="text-sm text-gray-600 space-y-2">
      <ul className="list-disc pl-5 space-y-1">
        <li>We collect basic user information such as name and email.</li>
        <li>Google Sign-In is used for secure authentication.</li>
        <li>We do not store user passwords.</li>
        <li>User data is used only to operate and improve the platform.</li>
        <li>Vehicle listings are visible to other users.</li>
        <li>We do not sell or misuse personal data.</li>
        <li>Basic security measures are used to protect information.</li>
        <li>Users can request data removal if needed.</li>
      </ul>
    </div>
  );
}
